import AuthLayout from "./AuthLayout";
import { useNavigate } from "react-router-dom";
import { Button, TextField } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { showError, showToast } from "../../constants/toasts";
import { OTP_ENUM } from "../../utils/enums";
import { useFormik } from "formik";
import { useForgotPasswordMutation } from "../../services/auth";
import * as Yup from "yup";
import Loader from "../../constants/Loader";
import useTranslation from "../../hooks/traslation";

const ForgotPassword = () => {
  const translation = useTranslation();
  const navigate = useNavigate();
  const [ForgotPasswordMutation, { isLoading }] = useForgotPasswordMutation();

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required(translation.error.emailReq)
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          translation.auth.enterValidEmail
        ),
    }),

    onSubmit: async () => {
      formik.setSubmitting(true);
      const body = {
        email: formik.values.email,
        // otpType: OTP_ENUM.FORGOT_PASSWORD,
      };
      try {
        // const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
        const response = await ForgotPasswordMutation(body).unwrap();

        if (response?.statusCode === 200) {
          const data = {
            email: formik.values.email,
          };
          navigate("/otp", { state: data });
          showToast(response?.message || translation.error.otpSent);
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (error: any) {
        showError(error?.data?.message || "");
        console.log(error);
      }
    },
  });

  return (
    <AuthLayout>
      <Loader isLoad={isLoading} />
      <div className="authBox">
        <h2>{translation.auth.forgotPassword}</h2>
        <p>{translation.auth.enterValidEmail}</p>
        <form onSubmit={formik.handleSubmit}>
          <div className="control_group">
            <label>{translation.auth.emailId}</label>
            <TextField
              placeholder={translation.auth.enterEmail}
              hiddenLabel
              fullWidth
              className="text_field"
              name="email"
              type="email"
              variant="outlined"
              id="email"
              onChange={(val) => {
                if (val.target.value === " " || val.target.value === ".") {
                  /* empty */
                } else {
                  formik.handleChange(val);
                }
              }}
              onBlur={formik.handleBlur}
              value={formik.values.email}
              helperText={formik.touched.email && formik.errors.email}
            />
          </div>
          <div className="form_btn">
            <Button className="btn btn_primary w_100" type="submit">
              {translation.globals.submit}
            </Button>
          </div>
        </form>
        <div className="auth_bottom">
          <p>
            <span className="link" onClick={() => navigate("/")}>
              <KeyboardBackspaceIcon /> {translation.auth.backToLogin}
            </span>
          </p>
        </div>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
